/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useCallback } from 'react';
import { useApolloClient } from '@apollo/react-hooks';
import { MutationCreateSoftAmendmentArgs } from 'lib/graphql';
import { processSoftAmendment } from './processSoftAmendment';

export const useSoftAmendment = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const client = useApolloClient();

  const createAndAcceptSoftAmendment = useCallback(async (variables: MutationCreateSoftAmendmentArgs) => {
    try {
      setError(undefined);
      setLoading(true);
      const amendment = await processSoftAmendment(client, variables);
      setLoading(false);
      return amendment;
    } catch (error) {
      setError(error);
      setLoading(false);
    }
  }, []);

  return { createAndAcceptSoftAmendment, loading, error };
};
